import React, { Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomDelete, SimpleModal } from 'components';
import { Images, PermissionList, RolePermission, useModal } from 'utils';
import { claimActions } from 'store';
import { SubmitBillModal } from '../submitBillModal';
import { claimDetailsStyle } from '../styles';
import { CLOSED_CLAIM } from '../constants';

const REFRESH_ACTION_TYPE = 'REFRESH_CLAIM';

export const RefreshClaim = ({ claimById, afterSuccess, btn }) => {
    const classes = claimDetailsStyle();
    const dispatch = useDispatch();
    const { open, close } = useModal();
    const [openPdf, setOpenPdf] = useState(false);

    return (
        <Fragment>
            {RolePermission([PermissionList.CLAIM_REFRESH?.code]) && claimById?.status !== CLOSED_CLAIM && (
                // claimById?.status !== PENDING_CLAIM &&
                <button
                    className={btn === 'simple' ? 'reset-btn-no-paddings' : classes.refreshClaimBtn}
                    type="button"
                    onClick={() => {
                        open(
                            <CustomDelete
                                text={`Are you sure you want to refresh the claim data? All fields will be populated with latest data, but will not be saved until the claim is resubmitted.`}
                                info="Refresh Claim Data"
                                handleDel={() => dispatch(claimActions.refreshClaim(claimById?.id))}
                                afterSuccess={() => {
                                    setOpenPdf(true);
                                    close();
                                }}
                                actionType={REFRESH_ACTION_TYPE}
                                color={'blue'}
                                innerText={'Refresh'}
                            />
                        );
                    }}
                >
                    <img src={Images.refresh} alt={'icon'} />
                </button>
            )}

            <SimpleModal
                handleOpenClose={() => setOpenPdf(false)}
                openDefault={openPdf}
                flexEnd={true}
                content={
                    <div>
                        <button
                            className="close-form-btn"
                            onClick={() => {
                                setOpenPdf(false);
                            }}
                        >
                            <img src={Images.closeButton} alt="close" />
                        </button>
                        <SubmitBillModal
                            claimById={claimById}
                            afterSuccess={afterSuccess}
                            handleClose={() => {
                                setOpenPdf(false);
                            }}
                        />
                    </div>
                }
            />
        </Fragment>
    );
};
